import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "./autosearch.css";
import { DateFormate } from "utils/DateFormate";

const AutoSearch = ({ items, setSearchItem, isTodo, isAgenda }) => {
  const [filterItems, setFilterItems] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (isTodo) {
      setFilterItems(
        items.filter((item) => {
          const name = item.todo;
          return name.toLocaleLowerCase().includes(value.toLocaleLowerCase());
        })
      );
    } else if (isAgenda) {
      setFilterItems(
        items.filter((item) => {
          const name = item.title;
          const searchUserEvents = item.users.filter((user) =>
            user.name.toLocaleLowerCase().includes(value.toLocaleLowerCase())
          );
          const dueDate = DateFormate(item.dueDate);
          const dueDate2 =
            dueDate.slice(0, dueDate.length - 8) +
            dueDate.slice(dueDate.length - 7, dueDate.length);

          const dueDateSearch =
            dueDate.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
            dueDate2.toLocaleLowerCase().includes(value.toLocaleLowerCase());

          if (searchUserEvents?.length) return true;
          if (dueDateSearch) return true;

          return name.toLocaleLowerCase().includes(value.toLocaleLowerCase());
        })
      );
    } else {
      setFilterItems(
        items.filter((item) => {
          const name = item.firstName + " " + item.lastName;
          return name.toLocaleLowerCase().includes(value.toLocaleLowerCase());
        })
      );
    }
    if (!value.length) setFilterItems([]);
  };

  const handleItem = (item) => {
    if (isTodo) setSearch(item.todo);
    else if (isAgenda) setSearch(item.title);
    else setSearch(item.firstName + " " + item.lastName);

    setSearchItem([item]);
    setFilterItems([]);
  };

  const handleClear = () => {
    setFilterItems([]);
    setSearchItem([]);
    setSearch("");
  };

  const renderUsersContent = () => {
    return (
      <>
        {filterItems.map((item, index) => (
          <div key={index} onClick={() => handleItem(item)} className="item">
            {item.firstName} {item.lastName}
          </div>
        ))}
      </>
    );
  };

  const renderTodosContent = () => {
    return (
      <>
        {filterItems.map((item, index) => (
          <div key={index} onClick={() => handleItem(item)} className="item">
            {isAgenda ? item.title : item.todo}
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="search-section">
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}>
        <InputBase
          sx={{ ml: 1, flex: 1, fontSize: "16px" }}
          onChange={handleSearch}
          value={search}
          placeholder="Search"
          inputProps={{ "aria-label": "search" }}
        />
        <IconButton
          sx={{ p: "10px" }}
          onClick={handleClear}
          aria-label="search">
          <HighlightOffIcon />
        </IconButton>
      </Paper>
      <div className={`suggestions ${filterItems.length ? "p-1" : ""} `}>
        {isTodo || isAgenda ? renderTodosContent() : renderUsersContent()}
      </div>
    </div>
  );
};

export default AutoSearch;
